module.exports = __webpack_public_path__ + "img/card_btn_cn.2dff4515.png";